import { render } from "./Friendship.vue?vue&type=template&id=1178bb82"
import script from "./Friendship.vue?vue&type=script&lang=js"
export * from "./Friendship.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__